import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M25.542 27.125a1.85 1.85 0 0 1-.459-1.23q0-.687.459-1.145l3.083-3.083H16.667q-.709 0-1.187-.48A1.6 1.6 0 0 1 15 20q0-.708.48-1.188a1.6 1.6 0 0 1 1.187-.479h11.958l-3.083-3.083a1.62 1.62 0 0 1-.5-1.187q0-.688.5-1.188a1.49 1.49 0 0 1 1.146-.5q.687 0 1.145.458l6 6q.25.25.355.542.105.291.104.625 0 .333-.104.625-.105.291-.355.542l-6 6q-.54.54-1.186.478a1.75 1.75 0 0 1-1.105-.52M8.333 35a3.21 3.21 0 0 1-2.355-.978A3.21 3.21 0 0 1 5 31.667V8.333q0-1.374.978-2.355A3.21 3.21 0 0 1 8.333 5h10q.71 0 1.189.478.478.48.478 1.189 0 .708-.478 1.186-.48.48-1.189.48h-10v23.334h10q.71 0 1.189.48.478.478.478 1.186 0 .709-.478 1.187-.48.48-1.189.48z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }